import { RootState } from '../store';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { Api } from "@/api/api";
import { Location } from "@/domain/location";

export interface LocationState {
  allLocations: Location[];
  locationToEdit: Location | undefined;
}

export const state: LocationState = {
  allLocations: [],
  locationToEdit: undefined
};

export const getters: GetterTree<LocationState, RootState> = {
  getAllLocations: state => state.allLocations,
  getLocationToEdit: state => state.locationToEdit
};

export const mutations: MutationTree<LocationState> = {
  SET_ALL_LOCATIONS: (state, locations) => {
    state.allLocations = locations
  },
  SET_LOCATION_TO_EDIT: (state, location) => state.locationToEdit = location
};

export const actions: ActionTree<LocationState, RootState> = {
  FETCH_ALL_LOCATIONS({ commit }) {
    return Api.Location.fetchAllLocations()
        .then(response => commit('SET_ALL_LOCATIONS', response.locations))
  },
  async SAVE_NEW_LOCATION({ commit }, newLocation: Location) {
    return await Api.Location.saveNewLocation(newLocation);
  },
  async UPDATE_LOCATION({ commit }, updatedLocation: Location) {
    return await Api.Location.updateLocation(updatedLocation);
  },
  async DELETE_LOCATION({ commit }, locationId : number) {
    return await Api.Location.deleteLocation(locationId);
  }
};

export const LocationStore: Module<LocationState, RootState> = {
  state,
  getters,
  mutations,
  actions
};
